/* eslint-disable */

import { bus } from '@/main';
import { mapGetters } from 'vuex';
import userList from '@/components/private/user-list-table';

export default {
  name: 'dashboard',
  components: {
    'user-list': userList
  },
  props: [],
  data() {
    return {
      preloader: false,
      dashboardData: null
    }
  },
  computed: {
    ...mapGetters([
      'getDashboardDetailsState',
    ]),
    getDashboardData() {
     this.dashboardData = this.$store.getters.getDashboardDetailsState.data;
     return;
    }
  },
  mounted() {
    bus.$emit('authBtnShowBus', true)
    this.getDashboardData;
  },
  methods: {
    ShowLoader() {
      setTimeout(() => {
        this.preloader = false
      }, 500)
    },
  },
  watch: {
    getDashboardData() {
      return this.$store.getters.getDashboardDetailsState
    }
  }
}